import type { UseSearchOrdersParams } from './types';

export type UseSearchOrdersQueryKey = readonly [
  'search',
  'orders',
  UseSearchOrdersParams,
];

export const getUseSearchOrdersQueryKey = (
  params: UseSearchOrdersParams,
): UseSearchOrdersQueryKey => ['search', 'orders', params];
